<div class="container">
  <div class="row">
    <ul class="nav custom-tabs mb-3" id="pills-tab" role="tablist">
      <div class="widget-theme">
        <li class="nav-item" role="presentation" *ngIf="isShowWidget">
          <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home"
            type="button" role="tab" aria-controls="pills-home" aria-selected="true" (click)="getWidget()">
            Widgets
          </button>
        </li>
        <!-- <li class="nav-item" role="presentation" *ngIf="isShowWidget">
          <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile"
            type="button" role="tab" aria-controls="pills-profile" aria-selected="false" (click)="storeDefaultWidget()">
            Custom Widgets
          </button>
        </li> -->
        <!-- <li class="nav-item" role="presentation" *ngIf="isShowWidget">
          <button class="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact"
            type="button" role="tab" aria-controls="pills-contact" aria-selected="false">
            Widget Themes
          </button>
        </li> -->
      </div>
      <div>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-theme"
            type="button" role="tab" aria-controls="pills-theme" aria-selected="false">
            Theme Color
          </button>
        </li>
      </div>
    </ul>
  </div>
</div>
<!-- first tab -->
<div class="tab-content" id="pills-tabContent">
  <!-- First Tab -->
  <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab"
    *ngIf="isShowWidget">
    <div class="container">
      <div class="row">
        <!-- <div class="col-md-12">
          <app-search #searchPlaceholder [placeholder]="dynamicPlaceholder" (keyup)="searchTable($event)"></app-search>
        </div> -->

        <div class="container mt-3">
          <div class="row">
            <div class="col-md-4">
              <p class="widget-p">Left Widgets</p>
              <div class="accordion-item">
                <div class="accordion-body">
                  <div cdkDropList [cdkDropListData]="leftWidgets" (cdkDropListDropped)="drop($event, 'left')"
                    class="category-list">
                    <div *ngFor="let i of leftWidgets; let index = index" cdkDrag class="category-item">
                      <label [ngClass]="{ 'custom-widget': i.type === 'custom' }">
                        <input type="checkbox" [(ngModel)]="i.checked" [disabled]="i.disabled" />
                        {{ i.widget_name }}
                      </label>

                      <!-- <i *ngIf="i.type === 'custom'" class="fa fa-edit ms-2 text-primary" (click)="onEditWidget(i)"
                        title="Edit" style="cursor: pointer"></i> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <p class="widget-p">Middle Widgets</p>
              <div class="accordion-item">
                <div class="accordion-body">
                  <div cdkDropList [cdkDropListData]="middleWidgets" (cdkDropListDropped)="drop($event, 'middle')"
                    class="category-list">
                    <div *ngFor="let i of middleWidgets; let index = index" cdkDrag class="category-item">
                      <label [ngClass]="{ 'custom-widget': i.type === 'custom' }">
                        <input type="checkbox" [(ngModel)]="i.checked" [disabled]="i.disabled" />
                        {{ i.widget_name }}
                      </label>

                      <!-- <i *ngIf="{ 'custom-widget': i.type === 'custom' }" 
                        title="Edit" style="cursor: pointer"></i> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <p class="widget-p">Right Widgets</p>
              <div class="accordion-item">
                <div class="accordion-body">
                  <div cdkDropList [cdkDropListData]="rightWidgets" (cdkDropListDropped)="drop($event, 'right')"
                    class="category-list">
                    <div *ngFor="let i of rightWidgets; let index = index" cdkDrag class="category-item">
                      <label [ngClass]="{ 'custom-widget': i.type === 'custom' }">
                        <input type="checkbox" [(ngModel)]="i.checked" [disabled]="i.disabled" />
                        {{ i.widget_name }}
                      </label>

                      <!-- <i *ngIf="i.type === 'custom'" class="fa fa-edit ms-2 text-primary" (click)="onEditWidget(i)"
                        title="Edit" style="cursor: pointer"></i> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="apply">
          <button type="button" class="btn cancel" (click)="onCancel()">
            Cancel
          </button>
          <button type="submit" class="btn submit" (click)="submitWidgets()">
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- second tab -->
  <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab"
    *ngIf="isShowWidget">
    <div class="container">
      <div class="col-md-12">
        <app-search #searchPlaceholder placeholder="Search" (keyup)="searchTable($event)"></app-search>
      </div>
      <div class="col-md-12">
        <form [formGroup]="widgetForm" (ngSubmit)="onSubmit()" class="col-md-12">
          <h5 class="tax-title py-3 m-0">Create Custom Widgets</h5>
          <div class="row">
            <!-- <div class="col-md-12 pb-2">
              <label class="form-label">Widget Name</label>
              <input type="text" class="form-control" formControlName="widget_name" [ngClass]="{
                  'is-invalid':
                    (submit && form['widget_name']?.errors) ||
                    (form['widget_name']?.invalid &&
                      (form['widget_name']?.dirty ||
                        form['widget_name']?.touched)),
                }" />
              <div *ngIf="
                  (submit && form['widget_name']?.errors) ||
                  (form['widget_name']?.invalid &&
                    (form['widget_name']?.dirty ||
                      form['widget_name']?.touched))
                " class="invalid-feedback">
                <span *ngIf="form['widget_name'].errors?.['required']" class="error-text">Widget name is required</span>
                <span *ngIf="form['widget_name'].errors?.['minlength']" class="error-text">Minimum length 3
                  character</span>
                <span *ngIf="form['widget_name'].errors?.['maxlength']" class="error-text">Maximum length 100
                  character</span>
                <span *ngIf="form['widget_name'].errors?.['pattern']" class="error-text">Allowed Only Letters and
                  Singlespace Between Words.</span>
              </div>
            </div> -->

            <div class="col-md-4 pb-2">
              <label class="form-label">Select Module</label>
              <select class="form-select" formControlName="module" [ngClass]="{
                  'is-invalid':
                    (submit && form['module'].errors) ||
                    (form['module'].invalid &&
                      (form['module'].dirty || form['module'].touched)),
                }">
                <option value="" disabled>Select Module</option>
                <option *ngFor="let module of moduleList" [value]="module.id">
                  {{ module.name }}
                </option>
              </select>
              <div *ngIf="
                  (submit && form['module']?.errors) ||
                  (form['module']?.invalid &&
                    (form['module']?.dirty || form['module']?.touched))
                " class="invalid-feedback">
                <span *ngIf="form['module'].errors?.['required']" class="error-text">Widget module is required</span>
              </div>
            </div>

            <div class="col-md-4 pb-2">
              <label class="form-label">Elements</label>
              <select class="form-select" formControlName="elements" [ngClass]="{
    'is-invalid':
      (submit && form['elements'].errors) ||
      (form['elements'].invalid &&
        (form['elements'].dirty || form['elements'].touched)),
  }">
                <option value="" disabled>Select Element</option>
                <option *ngFor="let element of filteredElements" [value]="element.id">
                  {{ element.name }}
                </option>
              </select>
              <div *ngIf="
                  (submit && form['elements']?.errors) ||
                  (form['elements']?.invalid &&
                    (form['elements']?.dirty || form['elements']?.touched))
                " class="invalid-feedback">
                <span *ngIf="form['elements'].errors?.['required']" class="error-text">Widget element is required</span>
              </div>
            </div>

            <div class="col-md-4 pd-2">
              <label class="form-label">Alignment Order</label>
              <input type="text" class="form-control" formControlName="alignment" [ngClass]="{
                  'is-invalid':
                    (submit && form['alignment'].errors) ||
                    (form['alignment'].invalid &&
                      (form['alignment'].dirty || form['alignment'].touched)),
                }" />
              <div *ngIf="
                  (submit && form['alignment']?.errors) ||
                  (form['alignment']?.invalid &&
                    (form['alignment']?.dirty || form['alignment']?.touched))
                " class="invalid-feedback">
                <span *ngIf="form['alignment'].errors?.['required']" class="error-text">Widget alignment is
                  required</span>
                <span *ngIf="form['alignment'].errors?.['min']" class="error-text">Minimum count 1 character</span>
                <span *ngIf="form['alignment'].errors?.['max']" class="error-text">Maximum count 100000 character</span>
                <span *ngIf="form['alignment'].errors?.['pattern']" class="error-text">Allowed Only numbers</span>
              </div>
            </div>

            <div class="col-md-4 py-2 text-center">
              <input type="radio" formControlName="position" [value]="1" class="mx-2 custom-radio"
                (click)="$event.preventDefault()" />Left
            </div>
            <div class="col-md-4 py-2 text-center">
              <input type="radio" formControlName="position" [value]="2" class="mx-2 custom-radio"
                (click)="$event.preventDefault()" />Middle
            </div>
            <div class="col-md-4 py-2 text-center">
              <input type="radio" formControlName="position" [value]="3" class="mx-2 custom-radio"
                (click)="$event.preventDefault()" />Right
            </div>
          </div>
          <div class="mt-3">
            <button type="button" class="btn btn-sm cancel" (click)="onCancel()">
              Cancel
            </button>
            <button type="submit" class="btn btn-sm submit">Create</button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- third tab -->
  <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab"
    *ngIf="isShowWidget"></div>

  <!-- Fourth Tab -->
  <div class="tab-pane fade" id="pills-theme" role="tabpanel" aria-labelledby="pills-contact-tab">
    <!-- Theme Color -->
    <div class="container">
      <!-- Header -->
      <div class="row my-2">
        <h5 class="tax-color py-2">Header Theme Color</h5>
        <div class="col-md-1 m-1 text-center parentPalatte" *ngFor="let color of headerColor">
          <span class="colorPalatte" [ngStyle]="{ 'background-color': color }" (click)="getheaderColor(color)"
            [class.active]="selectedHeaderColor===color.toLocaleLowerCase()"></span>
        </div>
        <div class="col-md-1 m-1 text-center parentPalatte align-content-center">
          <i class="fa-solid fa-palette fs-3" (click)="headerPicker()" title="Click Here"></i>
        </div>
      </div>

      <div class="row" *ngIf="headerFlag">
        <h5 class="tax-color py-2">Custom Color Options</h5>
        <div class="col-md-12">
          <label class="form-label col-md-6">Header Color</label>
          <input type="color" id="bg_color" [(ngModel)]="bg_color" (change)="getheaderColor($event)" /><span
            class="mx-2">{{ bg_color }}</span>
        </div>
        <div class="col-md-12">
          <label class="form-label col-md-6">Header Text Color</label>
          <input type="color" id="bg_text_color" [(ngModel)]="bg_text_color"
            (change)="getHeadertextcolor($event)" /><span class="mx-2">{{ bg_text_color }}</span>
        </div>
      </div>

      <!-- Sidebar -->
      <div class="row my-2">
        <h5 class="tax-color py-2">Sidemenu Theme Color</h5>
        <div class="col-md-1 m-1 text-center parentPalatte" *ngFor="let color of sidemenuColor">
          <span class="colorPalatte" [ngStyle]="{ 'background-color': color }" (click)="sidebarColor(color)"
            [class.active]="selectedSidebarColor === color.toLowerCase()"></span>
        </div>
        <div class="col-md-1 m-1 text-center parentPalatte align-content-center">
          <i class="fa-solid fa-palette fs-3" (click)="sidebarPicker()" title="Click Here"></i>
        </div>
      </div>

      <div class="row" *ngIf="sidebarFlag">
        <h5 class="tax-color py-2">Custom Color Options</h5>
        <!-- Sidebar Details -->
        <div class="col-md-12">
          <label class="form-label col-md-6">Sidebar Color</label>
          <input type="color" id="sidebar_color" [(ngModel)]="sidebar_color" (change)="sidebarColor($event)" /><span
            class="mx-2">{{ sidebar_color }}</span>
        </div>
        <div class="col-md-12">
          <label class="form-label col-md-6">Sidebar Text Color</label>
          <input type="color" id="sidebar_text_color" [(ngModel)]="sidebar_text_color"
            (change)="sidebarTextcolor($event)" /><span class="mx-2">{{ sidebar_text_color }}</span>
        </div>

        <!-- Hover Color Details -->
        <div class="col-md-12">
          <label class="form-label col-md-6">Menu Hover Color</label>
          <input type="color" id="link_hover_bg_color" [(ngModel)]="link_hover_bg_color"
            (change)="hoverBgColor($event)" /><span class="mx-2">{{ link_hover_bg_color }}</span>
        </div>
        <div class="col-md-12">
          <label class="form-label col-md-6">Menu Hover Text Color</label>
          <input type="color" id="link_hover_text_color" [(ngModel)]="link_hover_text_color"
            (change)="hoverTextColor($event)" /><span class="mx-2">{{ link_hover_text_color }}</span>
        </div>

        <!-- Active Menu Color -->
        <div class="col-md-12">
          <label class="form-label col-md-6">Active Menu Color</label>
          <input type="color" id="link_active_bg_color" [(ngModel)]="link_active_bg_color"
            (change)="linkActiveBgColor($event)" /><span class="mx-2">{{ link_active_bg_color }}</span>
        </div>
        <div class="col-md-12">
          <label class="form-label col-md-6">Active Menu Text Color</label>
          <input type="color" id="link_active_text_color" [(ngModel)]="link_active_text_color"
            (change)="linkActiveTextColor($event)" /><span class="mx-2">{{ link_active_text_color }}</span>
        </div>
        <div class="col-md-12">
          <label class="form-label col-md-6">Title Text Color</label>
          <input type="color" id="title_color" [(ngModel)]="title_color" (change)="titleColor($event)" /><span
            class="mx-2">{{ title_color }}</span>
        </div>
      </div>

      <!-- Sidebar Active Color -->
      <!-- <div class="row my-2">
        <h5 class="tax-color py-2">Sidemenu Active Theme Color</h5>
        <div class="col-md-1 m-1 text-center parentPalatte" *ngFor="let color of sidemenuActiveColor">
          <span class="colorPalatte" [ngStyle]="{ 'background-color': color }"
            (click)="linkActiveBgColor(color)"></span>
        </div>
        <div class="col-md-1 m-1 text-center parentPalatte align-content-center">
          <i class="fa-solid fa-palette fs-3" (click)="activeSidebarPicker()" title="Click Here"></i>
        </div>
      </div> -->
      <!-- <div class="row" *ngIf="sidebarActiveFlag">
        <h6 class="tax-color py-2">Sidemenu Active Color</h6>
        <div class="col-md-12">
          <label class="form-label col-md-6">Active Sidemenu Background Color</label>
          <input type="color" id="link_active_bg_color" [(ngModel)]="link_active_bg_color"
            (change)="linkActiveBgColor($event)"><span class="mx-2">{{link_active_bg_color}}</span>
        </div>
        <div class="col-md-12">
          <label class="form-label col-md-6">Active Sidemenu Text Color</label>
          <input type="color" id="link_active_text_color" [(ngModel)]="link_active_text_color"
            (change)="linkActiveTextColor($event)"><span class="mx-2">{{link_active_text_color}}</span>
        </div>
        <div class="col-md-12">
          <label class="form-label col-md-6">Title Text Color</label>
          <input type="color" id="title_color" [(ngModel)]="title_color" (change)="titleColor($event)"><span
            class="mx-2">{{title_color}}</span>
        </div>
      </div> -->

      <!-- Hover Theme Color -->
      <!-- <div class="row my-2">
        <h5 class="tax-color py-2">Hover Theme Color</h5>
        <div class="col-md-1 m-1 text-center parentPalatte" *ngFor="let color of hoverColor">
          <span class="colorPalatte" [ngStyle]="{ 'background-color': color }" (click)="hoverBgColor(color)"></span>
        </div>
        <div class="col-md-1 m-1 text-center parentPalatte align-content-center">
          <i class="fa-solid fa-palette fs-3" (click)="hoverPicker()" title="Click Here"></i>
        </div>
      </div> -->

      <!-- <div class="row" *ngIf="hoverFlag">
        <h6 class="tax-color py-2">Custom Color Options</h6>
        <div class="col-md-12">
          <label class="form-label col-md-6">Hover Background Color</label>
          <input type="color" id="link_hover_bg_color" [(ngModel)]="link_hover_bg_color"
            (change)="hoverBgColor($event)"><span class="mx-2">{{link_hover_bg_color}}</span>
        </div>
        <div class="col-md-12">
          <label class="form-label col-md-6">Hover Text Color</label>
          <input type="color" id="link_hover_text_color" [(ngModel)]="link_hover_text_color"
            (change)="hoverTextColor($event)"><span class="mx-2">{{link_hover_text_color}}</span>
        </div>
      </div> -->

      <div class="text-end">
        <button class="btn btn-sm cancel" type="button" (click)="resetTheme()">
          Reset Theme Color
        </button>
        <button class="btn btn-sm submit" type="button" (click)="colorpalletteSubmit()">
          Apply
        </button>
        <!-- <button class="btn btn-sm cancel" type="button" (click)="clear()">Clear</button> -->
      </div>
    </div>
  </div>
</div>